import {AfterViewInit, Component, forwardRef, NgModule, OnInit, ViewChild} from '@angular/core';
import {Events, NavParams, Platform, ViewController} from 'ionic-angular';
import {BT} from '../../../app/models/models';
import {MyApp} from "./../../../app/app.component";
import {ThemeProvider} from "../../../providers/theme/theme";

@Component({
  selector: 'page-bt-modal',
  templateUrl: 'bt-modal.html'
})

export class BTModalPage {
  bt: BT = new BT();
  btConfirmation: BT = new BT();
  wrongData: boolean = false;
  theme: string;

  @ViewChild('btNumber') btNumberInput;

  constructor(public navParams: NavParams,
              public viewCtrl: ViewController,
              public themeProvider: ThemeProvider) {

    this.bt = navParams.get('bt');

  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  confirm() {
    if (this.bt.number !== this.btConfirmation.number || this.bt.indice !== this.btConfirmation.indice) {
      this.wrongData = true;
    } else {
      this.viewCtrl.dismiss({valid: true});
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/bt/bt-modal/bt-modal.ts